import ResponseCode from "@/enums/ResponseCode";
import IBasicResponse from "@/interfaces/Data/IBasicResponse";
import { getSession } from "@/utils/Session";
import { QueryReturnValue } from "@reduxjs/toolkit/dist/query/baseQueryTypes";
import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";
import { Mutex } from "async-mutex";
const mutex = new Mutex();

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_BASE_URL,
  mode: "cors",
  prepareHeaders: (headers) => {
    const _SID = getSession("_SID");
    if (_SID) {
      headers.set("Authorization", `Bearer ${_SID}`);
    }
    if (headers.get("Content-Type") === 'multipart/form-data') {
      // 當上傳圖片時，刪除 Content-Type ，由系統自動添加
      // https://bobbyhadz.com/blog/error-multipart-boundary-not-found-in-express-js
      headers.delete("Content-Type");
    } else {
      headers.set("Content-Type", `application/json`);
    }
    return headers;
  },
});

export const baseQueryWithIntercept: BaseQueryFn<
  string | FetchArgs,
  IBasicResponse<any>,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  await mutex.waitForUnlock();

  let result: QueryReturnValue<any, FetchBaseQueryError, FetchBaseQueryMeta> =
    await baseQuery(args, api, extraOptions);

  const { data, error } = result;

  if (error) {
    return {
      error: {
        status: "CUSTOM_ERROR",
        data: (error.data as IBasicResponse<any>).code,
        error: "",
      },
    };
  }

  if (data && (data as IBasicResponse<any>)) {
    if (data.code === ResponseCode.SUCCESS) {
      return result;
    }
    return {
      error: {
        status: "CUSTOM_ERROR",
        data: (data as IBasicResponse<any>).code,
        error: (data as IBasicResponse<any>).message!!,
      },
    };
  } else {
    return result;
  }
};
